import { useRef, useEffect, useState } from 'react';

const useDebounce = (value, interval = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, interval);

    return () => {
      clearTimeout(timer);
    };
  }, [value, interval]);

  return debouncedValue;
};

export default useDebounce;
